import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/harmo/projects/Synetudes/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/harmo/projects/Synetudes/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["UnsavedChangesNavigationProvider"] */ "/home/harmo/projects/Synetudes/src/components/form/unsaved-changes-navigation-provider.tsx");
